var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e1ec2379a597f47bc19f65e3c34b744c55bf0053"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nextjs@minning"]={id:"e1ec2379a597f47bc19f65e3c34b744c55bf0053"};
      